import { render, staticRenderFns } from "./helpListDIS.vue?vue&type=template&id=2577934c"
import script from "./helpListDIS.vue?vue&type=script&lang=js"
export * from "./helpListDIS.vue?vue&type=script&lang=js"
import style0 from "./helpListDIS.vue?vue&type=style&index=0&id=2577934c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports